import React, { Component } from "react";
import { Translate, I18n } from "react-redux-i18n";
import { NavLink } from "react-router-dom";
import CreateMenuButton from "../../components/menu/CreateMenuButton";
import fetchRoute from "utils/routes";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { isPartner } from "utils/apiUtils";
import { withRouter } from "react-router-dom";
import MenuList from "assets/js/components/menu/MenuList";

class Navbar extends Component {
	constructor(props) {
		super(props);
		this.state = { showCampaignsOptions: false };
	}

	render() {
		//TODO
		//Add Analytics in menu when the related page will be created
		/*<li className="dashboard_analytics">
            <NavLink to="/analytics" activeClassName="active" className="lnk">
                <Translate value="app-menu-tab-title-analytics" />
            </NavLink>
        </li>*/

		return (
			<div id="menu" className={isPartner() ? "partner" : ""}>
				<nav className="main-nav center-xs">
					<ul>
						<li className="dashboard-option">
							<NavLink
								to={fetchRoute("dashboard")}
								activeClassName="active"
								className="lnk"
							>
								<Translate value="app-menu-tab-title-dashboard" />
							</NavLink>
						</li>
						<li
							className="dashboard_campaigns"
							onMouseEnter={() => {
								this.setState({ showCampaignsOptions: true });
							}}
							onMouseLeave={() => {
								this.setState({ showCampaignsOptions: false });
							}}
						>
							<NavLink
								to={fetchRoute("campaigns")}
								activeClassName="active"
								className="lnk"
							>
								<Translate value="app-menu-tab-title-campaigns" />
							</NavLink>
							{this.state.showCampaignsOptions && (
								<div className="campaigns-options">
									<div
										onClick={() => {
											this.props.history.push(fetchRoute("campaigns"));
										}}
									>
										<MenuList
											options={[
												{
													label: (
														<Translate value="app-menu-tab-campaign-label_regular_title" />
													),
													desc: I18n._translate(
														"app-menu-tab-campaign-label_regular_desc"
													),
													onClick: (e) => {
														e.stopPropagation();
														this.props.history.push(fetchRoute("campaigns"));
													},
												},
												{
													label: I18n._translate(
														"app-menu-tab-campaign-label_abtest_title"
													),
													desc: I18n._translate(
														"app-menu-tab-campaign-label_abtest_desc"
													),
													onClick: (e) => {
														e.stopPropagation();
														this.props.history.push(
															fetchRoute("campaignABTest")
														);
													},
												},
											]}
										/>
									</div>
								</div>
							)}
						</li>
						<li className="dashboard_automation">
							<NavLink
								to={fetchRoute("automation")}
								activeClassName="active"
								className="lnk"
							>
								<Translate value="app-menu-tab-title-automation" />
							</NavLink>
						</li>
						<li className="dashboard_contacts">
							<NavLink
								to={fetchRoute("contacts")}
								activeClassName="active"
								className="lnk"
							>
								<Translate value="app-menu-tab-title-contacts" />
							</NavLink>
						</li>
						<li className="dashboard_forms">
							<NavLink
								to={fetchRoute("forms")}
								activeClassName="active"
								className="lnk"
							>
								<Translate value="app-menu-tab-title-forms" />
							</NavLink>
						</li>
					</ul>
					<div className="create-button-container">
						<CreateMenuButton />
					</div>
				</nav>
			</div>
		);
	}
}
/*

<li className="dashboard_automation">
                            <NavLink to={fetchRoute("automation")} activeClassName="active" className="lnk">
                                <Translate value="app-menu-tab-title-automation" />
                            </NavLink>
                        </li>
 */

Navbar.propTypes = {
	account: PropTypes.object,
};

export default withRouter(
	connect((state) => {
		return {
			account: state.global.account,
			previewingBrand: state.global?.previewingBrand,
		};
	}, null)(Navbar)
);
